import { useCallback } from 'react'
import fileDownload from 'js-file-download'

import { sendRequestBlob } from './http-hook-blob'
import { useFeedback } from './feedback-hook'
import { useAlgoritmiCheckFileMutation } from './api-slice'

export const useDownloadFile = () => {
  const [algoritmiCheckFileMutation] = useAlgoritmiCheckFileMutation()

  const { setFeedback } = useFeedback()

  const downloadFile = useCallback(
    async (algorithm, type, exactlyOne, skipDownload, returnText) => {
      if (!algorithm) {
        setFeedback('Algoritmo non definito!')
        return
      }

      if (!type) {
        setFeedback('Tipo di file non definito!')
        return
      }

      const fileName = type === 'CSV' ? 'Output' : 'all'
      const arg = { algorithm, type, fileName }
      const result = await algoritmiCheckFileMutation(arg)

      if (result?.error) {
        setFeedback(result?.error?.data?.message)
        return
      }

      const fileNames = result?.data?.fileNames

      if (!fileNames?.length || (exactlyOne && fileNames.length !== 1)) {
        setFeedback('Nessun file trovato.')
        return
      }

      if (returnText && fileNames.length !== 1) {
        setFeedback('Impossibile mostrare più di un file.')
        return
      }

      const processFile = async file => {
        const fileData = await sendRequestBlob(
          `algoritmi/download/${algorithm}/${file}`,
        )
        if (!skipDownload) fileDownload(fileData, file)
        return fileData
      }

      try {
        if (returnText) {
          const fileData = await processFile(fileNames[0])
          return await fileData?.text()
        }

        // add some delay because some browsers do not download more than 10 files simultaneously
        const delayedDownload = () => {
          setTimeout(async () => {
            await processFile(fileNames[i])
            i++
            if (i < fileNames.length) delayedDownload()
          }, 500)
        }

        let i = 0
        delayedDownload()
        setFeedback(
          `File scaricat${fileNames.length === 1 ? 'o' : 'i'} correttamente.`,
          false,
          'Download completato',
        )
      } catch (err) {
        setFeedback(err.message)
      }
    },
    [algoritmiCheckFileMutation, setFeedback],
  )

  return { downloadFile }
}
